import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import SeoPage from "./pages/SeoPage";
import SeoAutoEngine from "./pages/SeoAutoEngine";
import ConsultingPage from "./pages/ConsultingPage";
import ManagedServicesPage from "./pages/ManagedServicesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AuthCallback from "./pages/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell() {
  const location = useLocation();
  // Handle OAuth callback synchronously before any protected route runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/seo" element={<SeoPage />} />
          <Route path="/seo/auto-engine" element={<SeoAutoEngine />} />
          <Route path="/consulting" element={<ConsultingPage />} />
          <Route path="/managed-services" element={<ManagedServicesPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
